/* global axios */
import ApiClient from './ApiClient';

class BugReportLabelsAPI extends ApiClient {
  constructor() {
    super('bug_report_labels', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(name, color) {
    return axios.post(this.url, { bug_report_label: { name, color } });
  }

  update(id, name, color) {
    return axios.patch(`${this.url}/${id}`, { bug_report_label: { name, color } });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

// Separate client for the bug_reports/:id/set_labels endpoint
class BugReportSetLabelsAPI extends ApiClient {
  constructor() {
    super('bug_reports', { accountScoped: true });
  }

  setLabels(bugReportId, labelIds) {
    return axios.patch(`${this.url}/${bugReportId}/set_labels`, { label_ids: labelIds });
  }
}

export const bugReportLabelsAPI = new BugReportLabelsAPI();
export const bugReportSetLabelsAPI = new BugReportSetLabelsAPI();
